import CaptchaStore from './CaptchaStore'

const initializeCaptcha = () => new CaptchaStore()

export type { default as CaptchaStore } from './CaptchaStore'
export default initializeCaptcha
